module.exports = __webpack_public_path__ + "algeria.svg?f904aff58900f884f70d6ea9cb004cf6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/algeria.svg
// module id = 88
// module chunks = 10